/* KST skin quiz: pure recommendation and helper logic. No DOM access. */
(function (root) {
  'use strict';

  var QUESTION_TYPES = ['single', 'multi', 'scale', 'date'];
  var RULE_KEYS = ['skin_concerns', 'routine_preference', 'skin_condition', 'skin_sensitivity', 'emotional_trigger',
    'relationship_motivation', 'emotional_meaning', 'purchase_objection', 'desired_outcome', 'concern_duration'];
  var CONCERN_PHRASES = {
    firmness: 'your cheeks and jawline looking less firm',
    mouth_lines: 'lines around your mouth becoming more noticeable',
    tired: 'skin that looks tired even when you are rested',
    glow: 'skin that has lost some of its glow',
    dark_spots: 'dark spots or uneven tone becoming more noticeable',
    maintain: ''
  };
  var OUTCOME_PHRASES = {
    confident: 'feeling beautiful and confident again',
    smoother: 'skin that looks smoother and firmer',
    refreshed: 'looking refreshed in photos',
    makeup_free: 'feeling comfortable without makeup',
    self_care: "knowing you're taking good care of yourself"
  };
  var CONDITION_PHRASES = {
    dry: 'Your skin often feels dry or tight, even after moisturizing.',
    rough: 'Your skin can feel rough or look dull.',
    comfortable: 'Your skin feels comfortable most of the time.',
    oily: 'Your skin tends to get oily or shiny.',
    combination: 'Your skin is oily in some areas and dry in others.'
  };
  var WHY = {
    S: 'Copper peptides and silk peptides to support firmness and soften the look of fine lines.',
    M: 'PDRN and collagen to cushion dryness and help skin hold moisture.',
    E: 'A light eye cream for the delicate skin around your eyes.',
    P: 'Your serum, moisturizer and eye cream together, for less than buying them separately.'
  };
  var PRACTICAL = ['disappointed', 'trust', 'consistency', 'steps'];

  function slug(s) {
    return String(s).toLowerCase().trim().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
  }

  function isObj(v) { return v !== null && typeof v === 'object' && !Array.isArray(v); }

  var KNOWN_CONCERNS = Object.keys(CONCERN_PHRASES);

  function usable(prod) {
    return isObj(prod) && typeof prod.variantId === 'number' && isFinite(prod.variantId) && prod.available !== false;
  }

  function knownConcerns(list) {
    return Array.isArray(list) ? list.filter(function (c) { return KNOWN_CONCERNS.indexOf(c) !== -1; }) : [];
  }

  function showIf(rule, answers) {
    if (typeof rule !== 'string' || !rule.trim()) return true;
    var m = rule.trim().match(/^([a-z0-9_]+)\s*(!=|=)\s*([a-z0-9_]+)$/i);
    if (!m) {
      console.warn('kst-quiz: ignoring malformed show_if "' + rule + '"');
      return true;
    }
    var a = isObj(answers) ? answers : {};
    var v = a[m[1]];
    var hit = Array.isArray(v) ? v.indexOf(m[3]) !== -1 : v === m[3];
    return m[2] === '=' ? hit : !hit;
  }

  function parseRichText(text, answers) {
    if (typeof text !== 'string') return [];
    var out = [];
    text.split(/\r?\n/).forEach(function (raw) {
      var line = raw.trim();
      var cond = line.match(/^\[([^\]]+)\]\s*(.*)$/);
      if (cond) {
        if (!showIf(cond[1], answers)) return;
        line = cond[2].trim();
      }
      if (!line) {
        if (out.length && out[out.length - 1].type !== 'break') out.push({ type: 'break' });
        return;
      }
      var bullet = line.match(/^[-•]\s+(.*)$/);
      if (bullet) {
        var body = bullet[1];
        var colon = body.indexOf(': ');
        var lead = colon > 0 && colon <= 32 ? body.slice(0, colon) : '';
        out.push({ type: 'li', text: lead ? body.slice(colon + 2) : body, lead: lead });
      } else {
        out.push({ type: 'p', text: line });
      }
    });
    while (out.length && out[out.length - 1].type === 'break') out.pop();
    return out;
  }

  function segmentFills(pct, n) {
    var count = isFinite(Number(n)) ? Math.max(0, Math.min(100, Math.floor(Number(n)))) : 0;
    var out = [];
    var p = Number(pct);
    for (var i = 0; i < count; i++) {
      if (!isFinite(p)) { out.push(0); continue; }
      out.push(Math.max(0, Math.min(100, Math.round((p - (i * 100) / count) * count))));
    }
    return out;
  }

  function parseOptions(text) {
    if (typeof text !== 'string') return [];
    var out = [];
    text.split(/\r?\n/).forEach(function (raw) {
      var line = raw.trim();
      if (!line) return;
      var i = line.indexOf('|');
      var label = i === -1 ? line : line.slice(0, i).trim();
      if (!label) return;
      var rest = i === -1 ? '' : line.slice(i + 1);
      var j = rest.indexOf('|');
      var value = (j === -1 ? rest : rest.slice(0, j)).trim();
      var image = j === -1 ? '' : rest.slice(j + 1).trim();
      var opt = { label: label, value: value || slug(label) };
      if (image) opt.image = image;
      out.push(opt);
    });
    return out;
  }

  function toggleMulti(selected, value, noneValue) {
    var cur = Array.isArray(selected) ? selected.slice() : [];
    if (noneValue && value === noneValue) {
      return cur.indexOf(noneValue) !== -1 ? [] : [noneValue];
    }
    cur = cur.filter(function (v) { return v !== noneValue; });
    var at = cur.indexOf(value);
    if (at === -1) cur.push(value); else cur.splice(at, 1);
    return cur;
  }

  function progressPct(screens, index) {
    if (!Array.isArray(screens) || screens.length === 0) return 0;
    var i = Math.max(0, Math.min(Number(index) || 0, screens.length));
    var total = 0;
    var before = 0;
    screens.forEach(function (s, n) {
      if (s && QUESTION_TYPES.indexOf(s.type) !== -1) {
        total += 1;
        if (n < i) before += 1;
      }
    });
    return total === 0 ? 0 : Math.round((100 * before) / total);
  }

  function assignVariant(stored, override, rand) {
    if (override === 'A' || override === 'B') return override;
    if (override === 'off') return 'A';
    if (stored === 'A' || stored === 'B') return stored;
    return rand() < 0.5 ? 'A' : 'B';
  }

  function buildProfile(a, concerns) {
    var named = concerns.map(function (c) { return CONCERN_PHRASES[c]; }).filter(Boolean).slice(0, 2);
    var first = named.length
      ? 'You have noticed ' + named.join(' and ') + '.'
      : 'You want to keep your skin looking its best.';
    var parts = [first];
    if (CONDITION_PHRASES[a.skin_condition]) parts.push(CONDITION_PHRASES[a.skin_condition]);
    if (a.skin_sensitivity === 'often' || a.skin_sensitivity === 'sometimes') {
      parts.push('It can react to new products, so we will keep things gentle.');
    }
    return parts.join(' ');
  }

  function pushIfUsable(items, missing, key, prod) {
    if (usable(prod)) items.push({ key: key, product: prod, why: WHY[key] });
    else missing.push(key);
  }

  function recommend(answers, products) {
    var a = isObj(answers) ? answers : {};
    var p = isObj(products) ? products : {};
    if (!p.S) throw new Error('kst-quiz: serum product (S) is not configured');
    var concerns = knownConcerns(a.skin_concerns);
    var size = a.routine_preference === 'one' || a.routine_preference === 'complete' ? a.routine_preference : 'two';
    var needM = size !== 'one' || a.skin_condition === 'dry' || a.skin_condition === 'rough';
    var needE = size === 'complete';
    var items = [];
    var missing = [];
    var protocol = false;

    if (needE && usable(p.P)) {
      items.push({ key: 'P', product: p.P, why: WHY.P });
      protocol = true;
    } else {
      if (needE) missing.push('P');
      items.push({ key: 'S', product: p.S, why: WHY.S });
      if (needM) pushIfUsable(items, missing, 'M', p.M);
      if (needE) pushIfUsable(items, missing, 'E', p.E);
    }

    return {
      items: items,
      protocol: protocol,
      pdpHandle: items[0].product.handle,
      profile: buildProfile(a, concerns),
      profileSlug: (a.skin_condition || 'unknown') + '-' + (concerns[0] || 'none'),
      missing: missing,
      incomplete: concerns.length === 0 || !a.routine_preference || !a.skin_condition
    };
  }

  function reassurance(answers) {
    var a = isObj(answers) ? answers : {};
    var emotional = 'neutral';
    if (a.emotional_trigger === 'partner' && a.relationship_motivation && a.relationship_motivation !== 'fine') emotional = 'A';
    else if (a.emotional_meaning === 'recognize') emotional = 'B';
    var practical = PRACTICAL.indexOf(a.purchase_objection) !== -1 ? a.purchase_objection
      : (a.routine_preference === 'one' ? 'steps' : null);
    return {
      emotional: emotional,
      practical: practical,
      sensitive: a.skin_sensitivity === 'often' || a.skin_sensitivity === 'sometimes'
    };
  }

  function compactAnswers(answers, max) {
    if (!isObj(answers)) return '{}';
    var out = {};
    var order = RULE_KEYS.concat(Object.keys(answers).filter(function (k) { return RULE_KEYS.indexOf(k) === -1; }));
    order.forEach(function (k) {
      if (!(k in answers)) return;
      out[k] = answers[k];
      if (JSON.stringify(out).length > max) delete out[k];
    });
    return JSON.stringify(out);
  }

  function cartPayload(rec, ctx, upsell, products) {
    var p = isObj(products) ? products : {};
    var c = isObj(ctx) ? ctx : {};
    var items = [];
    var missing = [];
    var list = isObj(rec) && Array.isArray(rec.items) ? rec.items : [];
    list.forEach(function (it) {
      var prod = it.product;
      var key = it.key;
      if (upsell && key === 'S' && usable(p.S3)) { prod = p.S3; key = 'S3'; }
      if (usable(prod)) items.push({ id: prod.variantId, quantity: 1 });
      else missing.push(key);
    });
    return {
      items: items,
      missing: missing,
      attributes: {
        kq_ab: c.ab || '',
        kq_capture: c.capture || '',
        kq_profile: isObj(rec) && rec.profileSlug ? rec.profileSlug : '',
        kq_utm_content: c.utmContent || '',
        kq_answers: compactAnswers(c.answers, 1000)
      }
    };
  }

  function checkoutUrl(code) {
    if (typeof code !== 'string' || !code.trim()) return '/checkout';
    return '/discount/' + encodeURIComponent(code.trim()) + '?redirect=%2Fcheckout';
  }

  function pdpUrl(handle, profileSlug, utmContent) {
    var url = '/products/' + handle + '?kq=1&kq_profile=' + encodeURIComponent(profileSlug);
    if (utmContent) url += '&utm_content=' + encodeURIComponent(utmContent);
    return url;
  }

  function matchPreset(presets, utmContent) {
    if (!Array.isArray(presets) || utmContent == null) return null;
    var want = String(utmContent).trim().toLowerCase();
    if (!want) return null;
    for (var i = 0; i < presets.length; i++) {
      var p = presets[i];
      var key = p ? String(p.utm_content || '').trim().toLowerCase() : '';
      if (key && key === want) return p;
    }
    return null;
  }

  function pickTestimonial(list, answers) {
    if (!Array.isArray(list) || list.length === 0) return null;
    var a = isObj(answers) ? answers : {};
    var concerns = knownConcerns(a.skin_concerns);
    var best = null;
    var bestScore = -1;
    list.forEach(function (t) {
      if (!t) return;
      var score = concerns.indexOf(t.concern) !== -1 ? 1 : 0;
      if (score > bestScore) { best = t; bestScore = score; }
    });
    return best;
  }

  // Fills {outcome} from the desired_outcome answer. Returns null when the
  // text needs an outcome the shopper has not given, so callers can fall back.
  function fillOutcome(text, answers) {
    if (typeof text !== 'string' || text.indexOf('{outcome}') === -1) return text;
    var a = isObj(answers) ? answers : {};
    var phrase = OUTCOME_PHRASES[a.desired_outcome];
    return phrase ? text.split('{outcome}').join(phrase) : null;
  }

  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  // Month labels for the results timeline, starting with the current month.
  function timeline(date, count, goalIndex) {
    var d = date instanceof Date && !isNaN(date) ? date : new Date();
    var n = Math.max(2, Math.floor(Number(count)) || 6);
    var g = Math.min(n - 1, Math.max(1, Math.floor(Number(goalIndex)) || 3));
    var labels = [];
    for (var i = 0; i < n; i++) labels.push(MONTHS[(d.getMonth() + i) % 12]);
    return { labels: labels, goalIndex: g, goalMonth: labels[g] };
  }

  // One non-empty trimmed entry per line (for example image URLs).
  function parseLines(text) {
    if (typeof text !== 'string') return [];
    return text.split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean);
  }

  // Splits "a __b__ c" into segments; text between double underscores is underlined.
  function underlineSegments(text) {
    if (typeof text !== 'string' || !text) return [];
    return text.split('__').map(function (t, i) { return { text: t, u: i % 2 === 1 }; }).filter(function (x) { return x.text; });
  }

  var api = {
    parseOptions: parseOptions,
    toggleMulti: toggleMulti,
    progressPct: progressPct,
    assignVariant: assignVariant,
    recommend: recommend,
    compactAnswers: compactAnswers,
    cartPayload: cartPayload,
    checkoutUrl: checkoutUrl,
    pdpUrl: pdpUrl,
    matchPreset: matchPreset,
    pickTestimonial: pickTestimonial,
    reassurance: reassurance,
    showIf: showIf,
    segmentFills: segmentFills,
    parseRichText: parseRichText,
    fillOutcome: fillOutcome,
    timeline: timeline,
    parseLines: parseLines,
    underlineSegments: underlineSegments
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.KstQuizRules = api;
})(typeof window !== 'undefined' ? window : this);
